<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            cols="12"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="ano"
              rules="required"
            >
              <b-form-group
                label="Ano"
                label-for="v-ano"
              >
                <b-form-input
                  id="v-ano"
                  v-model="form.ano"
                  placeholder="Ano"
                  :state="errors.length > 0 ? false : null"
                  data-cy="ano-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-ano-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- email -->
          <b-col
            cols="12"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="valor"
              rules="required"
            >
              <b-form-group
                label="Valor"
                label-for="v-valor"
              >
                <cleave
                  id="v-valor"
                  v-model.number="form.valor"
                  class="form-control"
                  :raw="true"
                  :options="options.number"
                  placeholder="valor"
                  data-cy="valor-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-valor-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="vencimento"
              rules="required"
            >
              <b-form-group
                label="Vencimento"
                label-for="v-vencimento"
              >
                <b-form-input
                  id="v-vencimento"
                  v-model="form.vencimento"
                  placeholder="vencimento"
                  :state="errors.length > 0 ? false : null"
                  data-cy="vencimento-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-vencimento-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="recorrencia"
              rules="required"
            >
              <b-form-group
                label="Recorrência"
                label-for="v-recorrencia"
              >
                <b-form-input
                  id="v-recorrencia"
                  v-model="form.recorrencia"
                  placeholder="recorrencia"
                  :state="errors.length > 0 ? false : null"
                  data-cy="recorrencia-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-recorrencia-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            lg="6"
          >
            <b-form-group
              label="Juros"
              label-for="v-juros"
            >
              <cleave
                id="v-juros"
                v-model.number="form.juros"
                class="form-control"
                :raw="true"
                :options="options.percent"
                placeholder="Juros"
                data-cy="juros-input"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            lg="6"
          >
            <b-form-group
              label="Multa"
              label-for="v-multa"
            >
              <cleave
                id="v-multa"
                v-model.number="form.multa"
                class="form-control"
                :raw="true"
                :options="options.percent"
                placeholder="Multa"
                data-cy="multa-input"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import Cleave from 'vue-cleave-component'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('contributionRangeSettingsModule', {
      contributionRange: state => state.contributionRange,
    }),
    canInsert() {
      return verificarPermissao('ROLE_FAIXA_CONTRIBUICAO_INSERIR')
    },
    canEdit() {
      return verificarPermissao('ROLE_FAIXA_CONTRIBUICAO_ATUALIZAR')
    },
    canEditOrInsert() {
      return (
        (!this.form.id && this.canInsert)
        || (this.form.id && this.canEdit)
      )
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    Cleave,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Faixa de Contribuição',
      required,
      form: {
        descricao: '',
        ano: '',
        valor: '',
        vencimento: '',
        recorrencia: '',
        juros: '',
        multa: '',
        ativo: true,
      },
      options: {
        number: {
          numeral: true,
          numeralDecimalMark: ',',
          numeralDecimalScale: 2,
          delimiter: '.',
        },
        percent: {
          numeral: true,
        },
      },
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.contributionRange))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch(
        'contributionRangeSettingsModule/resetContributionRange',
      )
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch(
                'contributionRangeSettingsModule/editContributionRange',
                this.form,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch(
                'contributionRangeSettingsModule/insertNewContributionRange',
                this.form,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        descricao: '',
        ano: '',
        valor: '',
        vencimento: '',
        recorrencia: '',
        juros: '',
        multa: '',
        ativo: true,
      }
    },
  },
}
</script>
